<template>
  <div :class="['szw-row szw-h-6 szw-w-40 szw-rounded', `szw-bg-section-static szw-animate-pulse`]"></div>

  <div :class="['szw-row szw-h-6 szw-w-full szw-max-w-67 szw-rounded', `szw-bg-section-static szw-animate-pulse`]"></div>

  <div :class="['szw-row szw-h-1 szw-max-w-67 szw-w-full szw-rounded', `szw-bg-section-static szw-animate-pulse`]"></div>

  <div class="szw-row__between szw-max-w-67 szw-w-full szw-rounded">
    <div :class="['szw-h-4 szw-w-12 szw-rounded', `szw-bg-section-static szw-animate-pulse`]"></div>
    <div :class="['szw-h-4 szw-w-12 szw-rounded', `szw-bg-section-static szw-animate-pulse`]"></div>
    <div :class="['szw-h-4 szw-w-12 szw-rounded', `szw-bg-section-static szw-animate-pulse`]"></div>
  </div>
</template>
